export class CommonCache {
  static welcomeInfoNotificationCacheKey() {
    return 'welcome-info-notification';
  }

  static welcomeNotificationCacheKey() {
    return 'welcome-notification';
  }
}
